export default function AttemptBadge({ attempt, required, testid }) {
  if (!required) return <span className="badge" data-testid={testid}>No test required</span>;
  if (!attempt) return <span className="badge info" data-testid={testid}>Not started</span>;
  if (attempt.status === "IN_PROGRESS") return <span className="badge warning" data-testid={testid}>In progress</span>;
  return <span className={`badge ${attempt.passed ? "success" : "danger"}`} data-testid={testid}>{attempt.passed ? "Cleared" : "Not cleared"} · {attempt.percent}%</span>;
}
